export const ABSTRACT_COMMAND = 'abstract_command';
